import { productBus } from '@/event/product/productBus'
import type { Option } from '@/storage/products'

export const getOptionValueNameById = (option_value_id: number, languageId: number) => {
  let optionName = ''

  if (productBus.value) {
    productBus.value.options.forEach((option: Option) => {
      const value = option.values?.find((v: any) => v.option_value_id === option_value_id)

      if (value) {
        const languageObject = value.language?.find((lang: any) => lang.language_id === languageId)

        if (languageObject) {
          optionName = languageObject.name
        }
      }
    })
  }

  return optionName
}
